<div class="chat-room-list-header">
  <span class="chat-room-list-title">Salas</span>
  @if (canCreateRoom) {
  <button type="button" class="btn-new-room" title="Nueva sala" (click)="openCreateRoom()">
    <span class="btn-icon-plus" aria-hidden="true"></span>
  </button>
  }
</div>

@if (rooms().length === 0) {
<div class="chat-room-list-empty">
  @if (roomsLoadError()) {
  No se han podido cargar las salas de chat.
  } @else {
  Todavía no tienes ninguna sala.
  }
</div>
} @else {
<ul class="chat-room-list">
  @for (room of rooms(); track room.IdChat) {
  <li class="chat-room-item" [class.is-selected]="room.IdChat === selectedRoomId" (click)="selectRoom(room)">
    <div class="chat-room-item-title">
      @if (room.IsDefaultTitle && room.Members.length === 1) {
      <span class="presence-dot" [class.online]="chatRealtimeService.isOnline(room.Members[0].IdUser)" aria-hidden="true"></span>
      }
      <span class="chat-room-item-title-text">{{ room.Title }}</span>
      @if (room.HasUnread) {
      <span class="chat-room-item-unread" aria-hidden="true"></span>
      }
      @if (room.LastMessageDate) {
      <span class="chat-room-item-date">{{ roomDateLabel(room.LastMessageDate) }}</span>
      }
    </div>
    @if (room.LastMessage) {
    <div class="chat-room-item-preview">{{ room.LastMessage }}</div>
    }
  </li>
  }
</ul>
}
